import { useState } from 'react';
import styled from 'styled-components';
import { SemanticUI } from '@iterable/deprecated_react_components';
import { GhostButton } from 'ui/button';
import { BaseCell } from './BaseCell';

// type Props = {
//   children?: React.Node,
//   ChildWrapper?: React.Node, // optional override for child style variations
//   label: string,
//   width?: number,
// };

// this keeps the label from breaking off the same line as the icon
const NoBreak = styled.span`
  white-space: nowrap;
`;

const StyledGhostButton = styled(GhostButton)`
  height: unset;
`;

const BlueIcon = styled(SemanticUI.Icon)`
  color: #2e8ece;
  vertical-align: middle;
  && {
    text-align: left;
    width: 15px;
  }
`;

const AccordionChildren = styled.div`
  margin-left: 20px;
  width: ${(props) => props.width};
  padding-left: 5px;
`;

const triangleDown = <BlueIcon size="large" name="triangle down" />;
const triangleRight = <BlueIcon size="large" name="triangle right" />;

const Accordion = ({ children, ChildWrapper = AccordionChildren, label = '', width }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const toggleAccordion = () => setIsAccordionOpen(!isAccordionOpen);
  return (
    <>
      <StyledGhostButton onClick={toggleAccordion} data-test="toggle-accordion">
        <NoBreak>
          {isAccordionOpen ? triangleDown : triangleRight}
          {label}
        </NoBreak>
      </StyledGhostButton>
      {isAccordionOpen && <ChildWrapper width={width}>{children}</ChildWrapper>}
    </>
  );
};

const createAccordionCell = (useBasecell /*: boolean */) => (props) =>
  useBasecell ? (
    <BaseCell>
      <Accordion {...props} />
    </BaseCell>
  ) : (
    <Accordion {...props} />
  );

export const AccordionCell = createAccordionCell(true);
export const CleanAccordionCell = createAccordionCell(false);
